<cb-dialog>
    <form class="flex-col flex" #form="ngForm">
        <div *cbWaitFor="mappedItem">
            <cb-display-value-new [value]="mappedItem.slotName" label="Name">
            </cb-display-value-new>
            <cb-display-value-new [value]="mappedItem.specGroupDto.label" label="Template Section">
            </cb-display-value-new>
            <cb-select
                name="costTypeControl"
                label="Cost Type"
                [options]="scheduleTemplateCostTypes"
                [required]="true"
                (change)="onCostTypeChange($event)"
                [(ngModel)]="mappedItem.costType"
            >
            </cb-select>
            <div class="flex-row" style="justify-content: space-between">
                <div class="flex-col" id="imageUploadDropzone" style="max-width: 180px">
                    <div class="start-center flex-row">
                        @if (
                            mappedItem.costType === COST_TYPE_ENUM.Actual ||
                            !mappedItem.scheduleItemImageUrl
                        ) {
                            <cb-image-button
                                [baseUrl]="mappedItem.productImageUrl"
                                class="image-button"
                            >
                            </cb-image-button>
                        }
                        @if (
                            mappedItem.costType !== COST_TYPE_ENUM.Actual &&
                            mappedItem.scheduleItemImageUrl
                        ) {
                            <cb-image-button
                                [baseUrl]="mappedItem.scheduleItemImageUrl"
                                class="image-button"
                            >
                            </cb-image-button>
                        }
                    </div>
                    <input
                        hidden
                        type="file"
                        #fileInput
                        (change)="selectFile($event.target.files[0], form.form)"
                        (click)="$event.target.value = null"
                        [disabled]="uploadingImage || mappedItem.costType === COST_TYPE_ENUM.Actual"
                        accept=".jpg,.jpeg,.png,.gif,image/jpeg,image/gif,image/png"
                    />
                    <div>
                        <button
                            mat-button
                            (click)="fileInput.click()"
                            style="display: block"
                            [disabled]="
                                uploadingImage || mappedItem.costType === COST_TYPE_ENUM.Actual
                            "
                        >
                            <mat-icon>delete</mat-icon>
                            @if (!mappedItem.productImageUrl && !mappedItem.scheduleItemImageUrl) {
                                <span> &nbsp;Upload Image </span>
                            }
                            @if (mappedItem.productImageUrl || mappedItem.scheduleItemImageUrl) {
                                <span> &nbsp;Replace Image </span>
                            }
                        </button>
                        @if (
                            mappedItem.scheduleItemImageUrl &&
                            mappedItem.costType !== COST_TYPE_ENUM.Actual
                        ) {
                            <button
                                mat-button
                                style="display: block"
                                (click)="removeImage(form.form)"
                            >
                                <mat-icon>delete</mat-icon>
                                &nbsp;Remove Image
                            </button>
                        }
                    </div>
                </div>
                <div class="flex-col" style="width: 100%; margin-left: 15px">
                    @if (categoryPathString && mappedItem.costType === COST_TYPE_ENUM.Actual) {
                        <cb-display-value-new
                            class="flex-row"
                            [value]="categoryPathString"
                            label="Product Category"
                        >
                        </cb-display-value-new>
                    }
                    <div class="start-center flex-row">
                        @if (mappedItem.costType === COST_TYPE_ENUM.Actual) {
                            <div class="flex">
                                <cb-product-centre-autocomplete-scroller
                                    class="cb-margin-right flex"
                                    label="Product"
                                    name="selectProduct"
                                    *cbWaitFor="categoryLoaded"
                                    [maxlength]="1499"
                                    [(ngModel)]="selectedProduct"
                                    [required]="true"
                                    [isInvalid]="!selectedProduct?.id"
                                    [businessEntityIds]="businessEntityIds"
                                    [requireMatch]="true"
                                    [matchProps]="['id']"
                                    [hideCompositeItems]="false"
                                    [orderByStandardProduct]="true"
                                    [categoryId]="offeringCategoryId"
                                    (searchTextChanged)="productSearchTextChanged($event)"
                                    (optionSelected)="productSelectedFromAutoComplete($event)"
                                >
                                </cb-product-centre-autocomplete-scroller>
                            </div>
                        }
                        @if (mappedItem.costType === COST_TYPE_ENUM.Actual) {
                            <cb-product-centre-find
                                name="selectedProduct"
                                class="product-centre-find"
                                [initializeSearchOnLoad]="true"
                                [categoryIdFilter]="offeringCategoryId"
                                [businessEntityIdsToSortBy]="businessEntityIds"
                                [restrictedBusinessEntityIds]="businessEntityIds"
                                [existingSlotItem]="existingSlotItem"
                                [showCurrentProduct]="true"
                                [currentProductTitle]="'Current Spec Item'"
                                [hideNationalRate]="true"
                                (productSelected)="productSelectedFromAutoComplete($event, true)"
                                [required]="true"
                                [buttonOnly]="true"
                                [maxlength]="1499"
                                [activeOnly]="true"
                            >
                            </cb-product-centre-find>
                        }
                    </div>
                </div>
            </div>
            @if (mappedItem.costType !== COST_TYPE_ENUM.Actual) {
                <div class="start-center flex-row">
                    <cb-input
                        class="flex"
                        type="text"
                        name="description"
                        label="Description"
                        [required]="true"
                        [maxlength]="1500"
                        [(ngModel)]="mappedItem.productOther"
                    >
                    </cb-input>
                </div>
            }
            <div class="flex-col">
                @if (form.controls?.quantity?.errors) {
                    <span class="error-msg mat-caption cb-error">
                        @if (form.controls.quantity.errors.required) {
                            <span>Quantity is a required field</span>
                        }
                        @if (form.controls.quantity.errors.maxlength) {
                            <span>
                                Quantity is not allowed to exceed a length of
                                {{ form.controls.quantity.errors.maxlength.requiredLength }} digits
                            </span>
                        }
                    </span>
                }
                @if (!shouldHideQuantity) {
                    <cb-input
                        name="quantity"
                        label="Quantity"
                        type="number"
                        class="flex-row"
                        [required]="true"
                        [maxlength]="16"
                        [suffix]="productUom"
                        [(ngModel)]="mappedItem.quantity"
                    >
                    </cb-input>
                }
                @if (isSupplierViewable()) {
                    <cb-select
                        class="flex-row"
                        name="supplierSelect"
                        label="Supplier"
                        [options]="suppliers"
                        [(ngModel)]="mappedItem.supplierId"
                    >
                    </cb-select>
                }
                @if (
                    mappedItem.costType &&
                    mappedItem.costType !== COST_TYPE_ENUM.Actual &&
                    mappedItem.costType !== COST_TYPE_ENUM.NoCharge &&
                    mappedItem.costType !== COST_TYPE_ENUM.DescriptiveOnly
                ) {
                    <cb-currency
                        class="flex-row"
                        [label]="getRateLabel()"
                        name="rateSnapshot"
                        [(ngModel)]="mappedItem.rateSnapshot"
                        [required]="
                            mappedItem.costType !== COST_TYPE_ENUM.Actual &&
                            mappedItem.costType !== COST_TYPE_ENUM.NoCharge
                        "
                        [inclGst]="mappedItem.costType === COST_TYPE_ENUM.Provisional"
                    >
                    </cb-currency>
                }
                <cb-nullable-boolean
                    class="flex-row"
                    label="Include in Flyer / Create Schedule"
                    name="showInClientSpecification"
                    [(ngModel)]="mappedItem.showInClientSpecification"
                    nullLabel="Not Set (Inherit from Product)"
                >
                </cb-nullable-boolean>
                <cb-nullable-boolean
                    class="flex-row"
                    label="Include in Colour Schedule"
                    name="showInColourYourDreams"
                    [(ngModel)]="mappedItem.showInColourYourDreams"
                    nullLabel="Not Set (Inherit from Product)"
                >
                </cb-nullable-boolean>
                <cb-nullable-boolean
                    class="flex-row"
                    label="Manual Colour Entry Required"
                    name="manualColourEntryRequired"
                    [(ngModel)]="mappedItem.manualColourEntryRequired"
                    nullLabel="Not Set (Inherit from Product)"
                >
                </cb-nullable-boolean>
            </div>
        </div>
    </form>
    <div actions>
        <span class="flex"></span>
        <button
            mat-raised-button
            color="primary"
            (click)="save()"
            [disabled]="form.pristine || form.invalid"
        >
            Save
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
